import { InlineWidget } from "react-calendly"
import { useTranslation } from "react-i18next"

const Calendly = () => {
    const {t} = useTranslation()
    return (
        <>
            <h1 className="text-center text-4xl sm:text-6xl py-4 sm:pt-16 text-orange-400">{t('calendlyh1')}</h1>
            <InlineWidget url="https://calendly.com/gogobits"  />
        </>
    )
}

export default Calendly